import {logo} from '../images'
export const prodjectExpansionData = [

  {
    title:"High Commander and Chief",
    logo:logo,
    profile:{},
    archivements:[
      {
        archivementYear:[
          {
            year:"2024",
            monthsInYear:[
           
              {
                months:"January",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:31,
                        dayTitle:"Wednessday",
                        achievementsInDay:[
                          {
                            achievementTitle:"withdraw Salary",
                            achievementDetail:[
                              {
                                name:"withdraw Salary from bank for sharing tomorrow",
                                amount:400000,
                              },
                            ],
                            achievementStatus:"pending"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"February",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                       
                        dayTitle:"Thursday",
                        dayNumber: "01" ,
                        Today:false,
                        achievementsInDay:[
                          {
                            achievementTitle:"share the budget for the month",
                            achievementDetail:[
                              {
                                name:"rent for the house",
                                amount:70000,
                              },
                              {
                                name:"money to mom",
                                amount:60000,
                              },
                              {
                                name:"internet",
                                amount:20000,
                              },
                              {
                                name:"water bills",
                                amount:10000,
                              },
                              {
                                name:"light bills",
                                amount:10000,
                              },
                              {
                                name:"transport for Nawal to and from school 500frs a day",
                                amount:5000,
                              },
                              {
                                name:"transport for Naomi to and from school 500frs a day",
                                amount:15000,
                              },
                              {
                                name:"transport for Aliya to and from office 300frs a day",
                                amount:5000,
                              },
                              {
                                name:"allowance Nawal",
                                amount:5000,
                              },
                              {
                                name:"allowance for Naomi",
                                amount:5000,
                              },
                              {
                                name:"allowance for Aliya",
                                amount:5000,
                              },
                              {
                                name:"food money 3000 frs a day",
                                amount:90000,
                              },
                              {
                                name:"my alawance",
                                amount:71000,
                              },
                              
                            ],
                            achievementStatus:"done"

                          },
                          {achievementTitle:"buy food for 3 days",
                            achievementDetail:[
                              {
                                name:"name of food 1 and ingredients",
                                amount:3000,
                              },
                              {
                                name:"name of food 2 and ingredients",
                                amount:3000,
                              },
                              {
                                name:"name of food 2 and ingredients",
                                amount:3000,
                              },
                            ]}
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"March",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:"01",
                        dayTitle:"Thursday",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"April",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:"01",
                        dayTitle:"Thursday",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"May",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"June",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:" 01",
                        dayTitle:"Thursday",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"July",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"August",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:"01",
                        dayTitle:"Thursday",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"September",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"October",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:"01",
                        dayTitle:"Thursday",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"November",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"December",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        dayNumber:"01",
                        dayTitle:"Thursday",
                        achievementsInDay:[
                          {
                            achievementTitle:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              }
            ]
          },
          {
            year:"2025",
            monthsInYear:[
              {
                months:"January",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"January",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"February",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"March",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"April",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"May",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"June",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"July",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"August",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"September",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"October",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"November",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set 1",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              },
              {
                months:"December",
                weeksInMonth:[
                  {
                    week:"week1",
                    daysInWeek:[
                      {
                        day:"day-01",
                        achievementsInDay:[
                          {
                            achievement:"work on a data set",
                            achievementStatus:"done"

                          }
                        ]
                    }
                    ]
                  }
                ]
              }
            ]
          }
        ],
       
      }
    ]

},
{
  title:"General 1",
  logo:logo,
  businessTitle:"Suber Craftex",
  BusinessDepartments:[
    
    {Department:[
      {name:"Marketing & money In"},
      {branch:[
        {name:"suberCraftex marketing"},
        {name:"camsol Technologies marketing",
          stages:[
            {name: 'e-marketing',
              levels:[
                {level : "investors",
                  methods:[
                    {method:"email",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"referal",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"social media",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                  ]
                },
                {level : "socializing(facebook etc)",
                  methods:[
                    {method:"facebook",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"linkin",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"whatsapp",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                  ]
                },
                {level: 'clients',
                  methods:[
                    {method:"email",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"referal",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"social media",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                  ]

                }
              ]

            },
            {name: 'physical marketing',
              levels:[
                {level : "investors",
                  methods:[
                    {method:"email",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"referal",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"social media",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                  ]
                },
                {level : "socializing(facebook etc)",
                  methods:[
                    {method:"facebook",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"linkin",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"whatsapp",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                  ]
                },
                {level: 'clients',
                  methods:[
                    {method:"email",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"referal",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                    {method:"social media",
                      users:[
                        {userProfile:{name:"mohamad"}}
                      ]
                    },
                  ]

                }
              ]
            }
          ]
        },

      ]}
    ]},
    {Department:[
      {name:"Branding"},
    ]},
    {Department:[
      {name:"finance"},
    ]},
    {Department:[
      {name:"Tech"},
    ]},
    {Department:[
      {name:"products"},
    ]},
    {Department:[
      {name:"Human resouce"},
    ]},
  ]
},
{
  title:"General 2",
  logo:logo,
 
},
{
  title:"General 3",
  logo:logo,
 
},
{
  title:"General 4",
  logo:logo,
 
}
]
